function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Energiebesparing-totaal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Energiebesparing-%-dit-jaar",
  transform: "translate(1.000000, 1.000000)",
  stroke: "#485156",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.1664,16.2 C24.1664,12.3934462 24.1664,10.2051975 24.1664,9.63525391 C24.1664,7.80519748 24.1664,5.06011285 24.1664,1.4 C24.1646002,1.0070838 23.9708104,0.639868805 23.6474562,0.416645975 C23.324102,0.193423146 22.9120371,0.142395286 22.544,0.28 L9.344,7.112 C8.87757388,7.28789549 8.56818805,7.73351293 8.5664,8.232 L8.5664,14.6",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 20.5664,
  y1: 7.4,
  x2: 24.1664,
  y2: 7.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.1664,
  y1: 12.2,
  x2: 24.1664,
  y2: 12.2,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.1664,
  y1: 19.4,
  x2: 3.7664,
  y2: 19.4,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.1664,
  y1: 24.2,
  x2: 6.1664,
  y2: 24.2,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.1664,
  y1: 5.6496,
  x2: 12.1664,
  y2: 0.2016,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1664,36.2 L12.1664,17 C12.1664,15.6745166 11.0918834,14.6 9.7664,14.6 L2.5664,14.6 C1.2409166,14.6 0.1664,15.6745166 0.1664,17 L0.1664,36.2 L11.5664,36.2",
  id: "Path"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M18,28.4666663 L19.0667241,28.4666663 C22.0124013,28.4666663 24.4003444,26.0788517 24.4003444,23.1333332 C24.4003444,21.9551258 25.3555217,21 26.5337926,21 C28.1328745,21 29.4291865,22.2962422 29.4291865,23.8952379 L29.4291865,25.2666664 C29.4291865,25.8557701 29.9067751,26.333333 30.4959106,26.333333 L30.8006889,26.333333 C31.7046892,26.3335801 32.5664145,26.7161378 33.1729052,27.386464 C33.7793959,28.0567903 34.0740679,28.9523453 33.9840983,29.851809 L33.6534138,33.1584755 C33.4350108,35.3393075 31.5997097,37 29.407852,37 L24.9977099,37 C24.6013082,37.0002552 24.2068337,36.9448573 23.8258373,36.8354277 L21.2352217,36.0979039 C20.8542254,35.9884743 20.4597508,35.9330764 20.0633491,35.9333325 L18,35.9333325 L18,28.4666663 Z",
  id: "Path",
  stroke: "#425CD4",
  strokeWidth: 2
}));
function SvgEnergiebesparingtotaal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "40px",
    viewBox: "0 0 36 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Energiebesparing totaal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergiebesparingtotaal);
export default __webpack_public_path__ + "static/media/Energiebesparing totaal.454fe0fdef145f24657dea745a0efe95.svg";
export { ForwardRef as ReactComponent };